import React from 'react'
import './Testimonial.scss'
// import { urlFor, client } from '../../client'
import { AppWrapper, MotionWrap } from '../../wrapper'

const Testimonial = () => {
  return (
    <div>Testimonial</div>
  )
}

export default AppWrapper(
    MotionWrap(Testimonial,  'testimonial'),
        
        'testimonial',
        'app__primarybg'
        );